import { render, staticRenderFns } from "./IcoachSkillSection.vue?vue&type=template&id=b10ec192&"
import script from "./IcoachSkillSection.vue?vue&type=script&lang=ts&"
export * from "./IcoachSkillSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports